export enum Anstellungstyp {
  AZUBI = 'AZUBI',
  EHRENAMTLICH = 'EHRENAMTLICH',
  KURZ_MIT_LSTK = 'KURZ_MIT_LSTK',
  KURZ_OHNE_LSTK = 'KURZ_OHNE_LSTK',
  MIDIJOB = 'MIDIJOB',
  MINIJOB = 'MINIJOB',
  PRAKTIKANT = 'PRAKTIKANT',
  SELBSTSTAENDIG = 'SELBSTSTAENDIG',
  TEILZEIT = 'TEILZEIT',
  VOLLZEIT = 'VOLLZEIT',
  WERKSTUDENT = 'WERKSTUDENT',
}
